<template>
  <section class="LoginPage Section">
    <aside class="LoginPage__aside">
      <p class="LoginPage__baseline">
        Le vin est un sujet trop sérieux<br />
        pour le traiter en se prenant au sérieux.
      </p>
      <img
        class="LoginPage__logo"
        src="../assets/images/logo.svg"
        alt="Logo CaptainVin"
      />
    </aside>

    <div class="LoginPage__content">
      <h1 class="LoginPage__title">Bienvenue</h1>
      <p class="LoginPage__introduction">
        CAPTAIN VIN c’est à la fois la garantie d’
        <b>offres particulièrement étudiées pour vous</b>
        - les professionnels de la restauration - avec des vins provenant
        <b>directement des domaines</b> ou via la plateforme que nous mettons à
        votre disposition. Mais également <b>un service sur mesure</b> de la
        prise d’information grâce à nos alertes (courriers) ou sur le site, au
        conseil téléphonique de votre Captain sur sa ligne directe.
      </p>
      <br />

      <!-- Cookie policy notice -->
      <section v-if="!isCookieAvailable" class="cookie-policy">
        <hr />
        <h3>Politique de gestion des cookies</h3>
        <p>
          Nous utilisons des cookies sur cette application pour vous offrir une
          expérience optimale.<br />
          En continuant sur ce site, vous confirmez avoir pris connaissance des
          <router-link :to="{ name: 'Cookies' }">conditions d'utilisation</router-link>
          du site
        </p>
        <button class="Button Button--primary" @click="setCookie()">
          J'accepte
        </button>
      </section>

      <!-- Login form -->
      <form @submit.prevent="login" class="LoginForm" v-else>
        <div class="InputGroup">
          <label class="InputGroup__label">Email</label>
          <Input
            :required="true"
            autocomplete="email"
            v-model="email"
            placeholder="Identifiant"
            data-cy="email"
            name="email"
          />
        </div>
        <div class="InputGroup">
          <label class="InputGroup__label">Password</label>
          <PasswordInput
            :required="true"
            autocomplete="current-password"
            v-model="password"
            placeholder="Mot de passe"
            data-cy="password"
            name="password"
          />
        </div>
        <div class="LoginForm__footer">
          <Button
            :loading="status === 'loading'"
            type="submit"
            data-cy="submit"
            class="Button Button--next"
          >
            Je me connecte&nbsp;
          </Button>
          <div class="LoginPage__links">
            <router-link class="forgotten-password" data-cy="password-recovery" :to="{name: 'PasswordRecovery'}">J'ai oublié mon mot de passe</router-link>
            <router-link class="forgotten-password" :to="{name: 'Signup'}">Demande d'inscription</router-link>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import Cookies from "js-cookie";
import Input from "../components/Input";
import PasswordInput from "../components/PasswordInput";
import Button from "../components/Button";
import notificationService from "../services/notification";

export default {
  data() {
    return {
      email: "",
      password: "",
      isCookieAvailable: false
    };
  },
  computed: {
    ...mapState("auth", ["status"])
  },
  methods: {
    login: function() {
      const email = this.email;
      const password = this.password;

      this.$store
        .dispatch("auth/login", { email, password })
        .then(() => this.$store.dispatch("cart/getCart"))
        .then(() => {
          const redirect = this.$route.query.redirect;

          this.setCookie();
          this.$router.replace(redirect ? redirect : "/");
        })
        .catch(err => {
          notificationService.error(err.message, err.errors);
        });
    },
    setCookie() {
      Cookies.set("logged", true, {
        expires: 30,
        sameSite: "strict"
      });

      this.isCookieAvailable = true;
    }
  },
  created() {
    this.isCookieAvailable = !!Cookies.get("logged");
  },
  components: { Input, PasswordInput, Button }
};
</script>

<style lang="scss">
@import '../assets/variables';
@import '../assets/login'
</style>
